import { useLayouts } from "../LayoutsProvider";
import NoLayout from "./NoLayout";
import HorizontalPreview from "./HorizontalPreview";
import { HorizontalSkeleton } from "./SkeletonsLayout";

const HeaderLayout = () => {
  const { loading, layouts } = useLayouts();

  if ( loading ) return <HorizontalSkeleton />;

  let headerLayouts = [];

  if ( layouts.length > 0 ) {

    layouts.map((current, index) => {
      if (current.layout_value === "header") headerLayouts.push(current);
    });

    if ( layouts.length > 0 && headerLayouts.length > 0 ) {
      return <HorizontalPreview source="header" layout={headerLayouts} />
    }
  }
  return <NoLayout source="header" />;
};

export default HeaderLayout;
